import { apiClient } from '@/shared/services/client'
import type {
  Password,
  PasswordDetail,
  PasswordCreateData,
  PasswordUpdateData,
  PasswordGroup,
  PasswordGroupCreateData,
  MessageResponse,
} from '../types'

export const passwordsApi = {
  // =========================================================================
  // GRUPOS
  // =========================================================================

  async getGroups(): Promise<PasswordGroup[]> {
    const response = await apiClient.get('/passwords/groups/')
    return response.data
  },

  async createGroup(data: PasswordGroupCreateData): Promise<PasswordGroup> {
    const response = await apiClient.post('/passwords/groups/', data)
    return response.data
  },

  async updateGroup(id: number, data: PasswordGroupCreateData): Promise<PasswordGroup> {
    const response = await apiClient.put(`/passwords/groups/${id}/`, data)
    return response.data
  },

  async deleteGroup(id: number): Promise<MessageResponse> {
    const response = await apiClient.delete(`/passwords/groups/${id}/`)
    return response.data
  },

  async reorderGroups(groupIds: number[]): Promise<MessageResponse> {
    const response = await apiClient.post('/passwords/groups/reorder/', { group_ids: groupIds })
    return response.data
  },

  // =========================================================================
  // CONTRASEÑAS
  // =========================================================================

  async getAll(groupId?: number): Promise<Password[]> {
    const params = groupId ? { group_id: groupId } : {}
    const response = await apiClient.get('/passwords/', { params })
    return response.data
  },

  async getOne(id: number): Promise<PasswordDetail> {
    const response = await apiClient.get(`/passwords/${id}/`)
    return response.data
  },

  async create(data: PasswordCreateData): Promise<Password> {
    const response = await apiClient.post('/passwords/', data)
    return response.data
  },

  async update(id: number, data: PasswordUpdateData): Promise<Password> {
    const response = await apiClient.put(`/passwords/${id}/`, data)
    return response.data
  },

  async delete(id: number): Promise<MessageResponse> {
    const response = await apiClient.delete(`/passwords/${id}/`)
    return response.data
  },

  // =========================================================================
  // Helpers
  // =========================================================================

  /**
   * Copia texto al portapapeles
   */
  async copyToClipboard(text: string): Promise<boolean> {
    // Fallback que funciona en más contextos
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.top = '0'
    textarea.setAttribute('readonly', '')
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    let success = false
    try {
      success = document.execCommand('copy')
    } catch {
      success = false
    }

    document.body.removeChild(textarea)

    // Si el fallback falla, intentar con la API moderna
    if (!success && navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text)
        success = true
      } catch {
        success = false
      }
    }

    return success
  },
}
